import _toConsumableArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/builds/vtblife/frontend/common/gatsby-party/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React, { useEffect, useMemo, useState } from 'react';
import classNames from 'classnames';
import s from './checkbox.module.css';
var colorRegexp = /(primary)|(error)|(alt)/g;
var MarkCheck = function MarkCheck(_ref) {
  var value = _ref.value,
    dirty = _ref.dirty;
  return React.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M6 10.5L9.11111 13L14 7",
    className: classNames(s.check, dirty ? value ? s.in : s.out : ''),
    stroke: "currentColor",
    fill: "none",
    strokeWidth: "2"
  }));
};
var MarkIndeterminate = function MarkIndeterminate() {
  return React.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M7 10H13",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2"
  }));
};
var RadioCircle = function RadioCircle() {
  return React.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("circle", {
    className: s.circle,
    cx: "10",
    cy: "10",
    r: "4",
    fill: "currentColor"
  }));
};
export var Checkbox = function Checkbox(_ref2) {
  var _ref2$value = _ref2.value,
    value = _ref2$value === void 0 ? false : _ref2$value,
    _ref2$indeterminate = _ref2.indeterminate,
    indeterminate = _ref2$indeterminate === void 0 ? false : _ref2$indeterminate,
    _ref2$disabled = _ref2.disabled,
    disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
    _ref2$color = _ref2.color,
    color = _ref2$color === void 0 ? 'primary' : _ref2$color,
    children = _ref2.children,
    onChange = _ref2.onChange,
    dataTest = _ref2.dataTest,
    _ref2$block = _ref2.block,
    block = _ref2$block === void 0 ? false : _ref2$block,
    _ref2$button = _ref2.button,
    button = _ref2$button === void 0 ? false : _ref2$button,
    _ref2$radio = _ref2.radio,
    radio = _ref2$radio === void 0 ? false : _ref2$radio,
    name = _ref2.name,
    gtm = _ref2.gtm,
    variant = _ref2.variant;
  var _useState = useState(value),
    _useState2 = _slicedToArray(_useState, 2),
    on = _useState2[0],
    setValue = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    dirty = _useState4[0],
    setDirty = _useState4[1];
  var handleToggleValue = function handleToggleValue(event) {
    setValue(event.target.checked);
    setDirty(true);
    if (onChange) {
      onChange(event.target.checked, event);
    }
  };
  var colors = useMemo(function () {
    return color.match(colorRegexp) || [];
  }, [color]);
  useEffect(function () {
    return setValue(value);
  }, [value]);
  return React.createElement("label", {
    "data-test": dataTest,
    "data-gtm": gtm,
    className: classNames.apply(void 0, [s.label].concat(_toConsumableArray(colors.map(function (v) {
      return s[v];
    })), [disabled && s.disabled, block && s.block, (button || variant === 'button') && s.button, radio && s.radio, on && s.checked, variant === 'filter' && s.filter]))
  }, React.createElement("input", {
    type: radio ? 'radio' : 'checkbox',
    className: s.input,
    checked: on,
    disabled: disabled,
    onChange: handleToggleValue,
    name: name
  }), React.createElement("div", {
    className: s.border
  }), React.createElement("div", {
    className: classNames(s.control, children && s.gap),
    "data-checkbox-control": true
  }), React.createElement("div", {
    className: s.icon
  }, !radio && !indeterminate && React.createElement(MarkCheck, {
    value: on,
    dirty: dirty
  }), !radio && indeterminate && React.createElement("div", {
    className: s.minus
  }, React.createElement(MarkIndeterminate, null)), radio && React.createElement(RadioCircle, null)), children && React.createElement("div", {
    className: s.text
  }, children));
};